import { gql, useQuery } from "@apollo/client";

export const GET_PO_NUMBERS = gql`
  query getPurchaseOrderNumbers(
    $accountId: ID!
    $search: String
    $venueIds: [ID!]
    $subvenueIds: [ID!]
    $roleRateIds: [ID!]
  ) {
    account {
      targetAccount(accountId: $accountId) {
        purchaseOrderNumbers(
          venueIds: $venueIds
          subvenueIds: $subvenueIds
          roleRateIds: $roleRateIds
          search: $search
        ) {
          id
          purchaseOrderNumber
          venueId
          venue {
            id
            name
          }
          subvenueId
          subvenue {
            id
            name
          }
          roleRateId
          role {
            id
            name
          }
          startDate
          endDate
          status
        }
      }
    }
  }
`;

export const useGetPurchaseOrderNumbers = (
  accountId,
  search,
  { venueIds = [], subvenueIds = [], roleRateIds = [] } = {}
) => {
  const { data, loading, error, refetch } = useQuery(GET_PO_NUMBERS, {
    variables: {
      accountId,
      search,
      venueIds,
      subvenueIds,
      roleRateIds
    },
    fetchPolicy: "cache-and-network"
  });

  return {
    purchaseOrderNumbers:
      data?.account?.targetAccount?.purchaseOrderNumbers ?? [],
    loading,
    error,
    refetch
  };
};
